if (!customElements.get("sticky-atc")) {
  class StickyATC extends HTMLElement {
    constructor() {
      super({
        name: "Sticky ATC",
        version: "2.0.0",
      });
    }

    connectedCallback() {
      this.stickyATCUpper = document.querySelector(".section-main-product");

      if (!this.stickyATCUpper) return;

      this.buttonWrapper = this.querySelector(".sticky-atc-button");
      this.colorSelector = this.querySelector(".product__color-selector");
      this.variantSelector = this.querySelector(".product__variant-item");
      this.mobileSizeSelectorButton = this.querySelector(".product__size-selector--button");
      this.productInfo = document.querySelector("product-info");
      this.variantTriggers = this.querySelectorAll(".open-variants");
      this.colourTriggers = this.querySelectorAll(".open-colours");
      this.variantOptions = [...this.querySelectorAll(".variant-radios__label"), ...document.querySelectorAll(".product__info--details .variant-radios__label")];

      document.documentElement.style.setProperty("--footer-offset", `${this.offsetHeight}px`);

      this.variantTriggers.forEach((trigger) => {
        trigger.addEventListener("click", this.toggleVariantSelectorDrawer.bind(this));
      });

      this.colourTriggers.forEach((trigger) => {
        trigger.addEventListener("click", this.toggleColorSelectorDrawer.bind(this));
      });

      this.variantOptions.forEach((trigger) => {
        trigger.addEventListener("click", this.toggleActiveButton.bind(this));
      });

      this.mobileSizeSelectorButton?.addEventListener("click", this.mobileVariantSelector.bind(this));
    }

    disconnectedCallback() {
      if (!this.stickyATCUpper) return;
    }

    toggleColorSelectorDrawer() {
      this.colorSelector.classList.toggle("active");
      this.variantSelector?.classList.remove("active");
    }

    toggleVariantSelectorDrawer() {
      this.variantSelector.classList.toggle("active");
      this.colorSelector?.classList.remove("active");
    }

    toggleActiveButton() {
      this.mobileSizeSelectorButton.classList.add("hidden");
      this.colorSelector?.classList.remove("active");
      this.buttonWrapper.classList.remove("hidden");
    }

    mobileVariantSelector() {
      if (!this.productInfo) return;

      this.productInfo.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  customElements.define("sticky-atc", StickyATC);
}
